import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { addMonths, differenceInMonths, format } from "date-fns";
import { v4 as uuidv4 } from 'uuid';
import { getTeam } from "../../../../services/GlobalRoles/getTeam";
import { getLands } from "../../../../services/GlobalRoles/getLands";
import { sendSimulation } from "../../../../services/Simulator/sendSimulation";
import { formatIsoDate } from "../../../../utils/formatDate";
import { useLocation, useParams } from "react-router-dom";
import { sendPublicSimulation } from "../../../../services/Public/sendPublicSimulation";
import { formatStyledCurrency } from "../../../../utils/formatStyledCurrency";
import { getEnvironment, getUserId, getUserRole } from "../../../../utils/auth";

const SimulatorContext = createContext();

export const SimuladorProvider = ({ children }) => {
  // const environment_id = getEnvironment();
  // const environment_id = 0;
  // console.log("Environment ID (SimulatorContext): ", environment_id);
  const [crmData, setCrmData] = useState(null);

  const { state } = useLocation();

  const empId = state?.empId || crmData?.empId || 0;

  const { hash, role, enterpriseId } = useParams();

  const isPublic = hash ? true : false;

  const [testId, setTestId] = useState(null);
  const [skeleton, setSkeleton] = useState(true);
  const [simulationDataLoading, setSimulationDataLoading] = useState(false);

  const [configVisible, setConfigVisible] = useState(false);
  const [firstVisible, setFirstVisible] = useState(true);

  const [landValue, setLandValue] = useState(null);

  const [team, setTeam] = useState(null);
  const [member, setMember] = useState(null);
  const [members, setMembers] = useState(null);
  const [blocks, setBlocks] = useState(null);
  const [currentBlock, setCurrentBlock] = useState(null);
  const [lands, setLands] = useState(null);
  const [currentLand, setCurrentLand] = useState(null);

  const [pricingTables, setPricingTables] = useState([]);

  const [entryValue, setEntryValue] = useState(0);
  const [minEntryValue, setMinEntryValue] = useState(0);
  const [entryRange, setEntryRange] = useState(0);
  const [simulatorData, setSimulatorData] = useState(null);
  const [simulationData, setSimulationData] = useState(null);
  const [selectedEntryTerm, setSelectedEntryTerm] = useState(1);

  const [entryParcelValue, setEntryParcelValue] = useState(0);
  const [entryTerms, setEntryTerms] = useState([]);
  const [entryParcelsTableVisible, setEntryParcelsTableVisible] =
    useState(false);
  const [entryParcelsTable, setEntryParcelsTable] = useState([]);

  const [entryInterest, setEntryInterest] = useState(0);
  const [constructionInterest, setConstructionInterest] = useState(0);
  const [intermediateInterest, setIntermediateInterest] = useState(0);
  const [financingInterest, setFinancingInterest] = useState(0);

  const [firstEntryParcelDate, setFirstEntryParcelDate] = useState(null);
  const [othersEntryParcelDate, setOthersEntryParcelDate] = useState(null);

  const [selectedPricingTable, setSelectedPricingTable] = useState(null);

  const [constructionValue, setConstructionValue] = useState(null);
  const [minConstructionValue, setMinConstructionValue] = useState(null);
  const [constructionRange, setConstructionRange] = useState(null);
  const [firstConstructionParcelDate, setFirstConstructionParcelDate] =
    useState(null);
  const [othersConstructionParcelDate, setOthersConstructionParcelDate] =
    useState(null);
  const [selectedConstructionTerm, setSelectedConstructionTerm] = useState(1);
  const [constructionParcelsTable, setConstructionParcelsTable] =
    useState(null);
  const [constructionTotalValue, setConstructionTotalValue] = useState(0);
  const [constructionFinalValue, setConstructionFinalValue] = useState(0);

  const [date, setDate] = useState(null);

  const [financingValue, setFinancingValue] = useState(0);

  const [financingParcelCalc, setFinancingParcelCalc] = useState(0);

  const [selectedFinancingTerm, setSelectedFinancingTerm] = useState(1);

  const [financingTerms, setFinancingTerms] = useState([]);
  const [financingParcelValue, setFinancingParcelValue] = useState(0);
  const [financingParcelsTableVisible, setFinancingParcelsTableVisible] =
    useState(false);

  const [financingRate, setFinancingRate] = useState(null);
  const [financingParcelsTable, setFinancingParcelsTable] = useState([]);

  const [entryParcelCalc, setEntryParcelCalc] = useState(0);

  const [oneTimeParcelValue, setOneTimeParcelValue] = useState(0);
  const [oneTimeParcelDate, setOneTimeParcelDate] = useState(null);
  const [oneTimeInstallments, setOneTimeInstallments] = useState(null);
  const [oneTimeValueAndPercentage, setOneTimeValueAndPercentage] = useState([
    null,
  ]);

  const [selectedOneTimePayTerm, setSelectedOneTimePayTerm] = useState(1);
  const [firstIntermediateParcelDate, setFirstIntermediateParcelDate] =
    useState(null);
  const [selectedIntermediateTerm, setSelectedIntermediateTerm] = useState(1);
  const [intermediateTerms, setIntermediateTerms] = useState(null);
  const [intermediateParcelValue, setIntermediateParcelValue] = useState(null);
  const [intermediateParcelsTable, setIntermediateParcelsTable] =
    useState(null);

  const [intermediateMonthsPeriod, setIntermediateMonthsPeriod] = useState(0);
  const [intermediateValue, setIntermediateValue] = useState(null);
  const [intermediateFinalValue, setIntermediateFinalValue] = useState(0);
  const [intermediateTotalValue, setIntermediateTotalValue] = useState(0);
  const [minIntermediateValue, setMinIntermediateValue] = useState(null);
  const [intermediateRange, setIntermediateRange] = useState(null);

  const [discount, setDiscount] = useState(0);

  const [totalOrderPrice, setTotalOrderPrice] = useState(0);

  const [showModalClient, setShowModalClient] = useState(false);

  const [oneTimePayTerms, setOneTimePayTerms] = useState([]);

  const [firstOneTimePayDate, setFirstOneTimePayDate] = useState(null);
  const [othersOneTimePayDate, setOthersOneTimePayDate] = useState(null);

  const [clientId, setClientId] = useState(null);
  const [clientData, setClientData] = useState(null);

  const [memberData, setMemberData] = useState(null);

  const [stage, setStage] = useState(0);

  const [simulationId, setSimulationId] = useState(null);

  const [imobiliarias, setImobiliarias] = useState([]);
  const [corretores, setCorretores] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [others, setOthers] = useState([]);

  const [selectedImob, setSelectedImob] = useState(null);
  const [selectedCorr, setSelectedCorr] = useState(null);

  const [hasMap, setHasMap] = useState({ file: null });
  const [saveImageMap, setSaveImageMap] = useState(null);

  const [toggle, setToggle] = useState(false);
  const [loadingTeams, setLoadingTeams] = useState(false);
  const [loadingLands, setLoadingLands] = useState(false);

  const [chooseEntry, setChooseEntry] = useState(false);
  const [chooseEntryInstallments, setChooseEntryInstallments] = useState(false);
  const [publicClientData, setPublicClientData] = useState(null);
  const [chooseEntryData, setChooseEntryData] = useState([
    { id: 1, valorTotal: minEntryValue, vencimento: new Date(), intervaloDias: 30, quantidadeParcelas: 1, obs_sale: "" },
  ]);

  const handleTeam = async (value) => {
    setLoadingTeams(true);
    setTeam(value);
    // console.log(value);

    const currentTeam = simulatorData.teams.filter(t => t.id === value);
    // console.log(currentTeam);
    const response = currentTeam[0];
    // const response = await getTeam(value);
    // console.log(response);

    if (!response?.members || response?.members.length <= 0) {
      toast.error("Não há membros!");
      return;
    }
    // console.log("response.members: ", response.members);
    setMembers(response.members);

    const imobiliariasFiltered = response.members.filter((member) =>
      member.registration_types.some(
        (registration) => registration.id === 9
      )
    );
    const corretoresFiltered = response.members.filter((member) =>
      member.registration_types.some(
        (registration) => registration.id === 8
      )
    );
    const othersFiltered = response.members.filter(
      (member) =>
        !member.registration_types.some(
          (registration) => registration.id === 9
        ) &&
        !member.registration_types.some(
          (registration) => registration.id === 8
        )
    );

    if (imobiliariasFiltered) {
      const imobMembers = imobiliariasFiltered.map((i) => ({
        value: i.id,
        label: i.name,
      }));
      setImobiliarias(imobMembers);
    }

    if (corretoresFiltered) {
      const role = getUserRole();
      const userId = parseInt(getUserId());
      // console.log(role)
      // console.log(userId)
      // Verifica se a role é "Corretor"
      let sellerMembers = corretoresFiltered.map((i) => ({
        value: i.id,
        label: i.name,
      }));

      // Se o usuário for um corretor, filtra apenas seu próprio id
      if (role === 'Corretor') {
        sellerMembers = sellerMembers.filter((i) => i.value === userId);
      }

      setCorretores(sellerMembers);
    }
    setOthers(othersFiltered);
    setLoadingTeams(false);
  };

  // Versão original comentada abaixo:
  // async function generateEntryTerms(maxValue) {
  //   const entryTerms = [];
  //   let increment = 1;

  //   for (let value = 1; value <= maxValue; value += increment) {
  //     entryTerms.push({ value: value, label: `${value}x` });
  //     if (value === 12) {
  //       increment = 12;
  //     }
  //     if (value + increment >= maxValue) {
  //       entryTerms.push({ value: maxValue, label: `${maxValue}x` });
  //       break;
  //     }
  //   }
  //   return entryTerms;
  // }

  // Nova versão: lista todos os termos em sequência, sem agrupar por 12
  async function generateEntryTerms(maxValue) {
    const entryTerms = [];
    for (let value = 1; value <= maxValue; value++) {
      entryTerms.push({ value: value, label: `${value}x` });
    }
    return entryTerms;
  }

  function translatePricingTablesTagToPortuguese(optionName) {
    switch (optionName) {
      case "price":
        return "Price";
      case "sac":
        return "SAC";
      case "sac_inverso":
        return "SAC Inverso";
      case "sacre":
        return "Sacre";
      case "sacre_ib":
        return "Sacre IB";
      case "sacoc":
        return "SACOC";
      case "interest_free":
        return "Sem Juros";
      default:
        return optionName;
    }
  }

  // async function generateFinancingTerms(maxValue) {
  //   const financingTerms = [];
  //   let increment = 1;

  //   for (let value = 1; value <= maxValue; value += increment) {
  //     // Adiciona o valor atual e o rótulo correspondente
  //     financingTerms.push({ value: value, label: `${value}x` });

  //     // Ajusta o incremento para 12 após o valor ser 12
  //     if (value === 12) {
  //       increment = 12;
  //     }

  //     // Se o próximo incremento ultrapassar o maxValue, ajusta para o maxValue diretamente
  //     if (value + increment >= maxValue) {
  //       financingTerms.push({ value: maxValue, label: `${maxValue}x` });
  //       break;
  //     }
  //   }

  //   return financingTerms;
  // }

  // Nova versão: lista todos os termos em sequência, sem agrupar por 12
  async function generateFinancingTerms(maxValue) {
    const financingTerms = [];
    for (let value = 1; value <= maxValue; value++) {
      financingTerms.push({ value: value, label: `${value}x` });
    }
    return financingTerms;
  }

  // async function generateOneTimeTerms(maxValue) {
  //  //   console.log("Max Value: ", maxValue);
  //   const oneTimeTerms = [];
  //   const valueAndPercentage = [];
  //   for (const term of maxValue) {
  //     const { max_installments, percentage } = term;
  //     const discountValue =
  //       (parseFloat(landValue).toFixed(2) * parseFloat(percentage)) / 100;
  //     const labelValue = (landValue - discountValue) / max_installments;
  //     oneTimeTerms.push({
  //       value: max_installments,
  //       label: `${max_installments}x - ${formatCurrency(
  //         labelValue.toString()
  //       )}`,
  //     });

  //     valueAndPercentage.push({
  //       term: max_installments,
  //       percentage: percentage,
  //       value: landValue - discountValue,
  //     });
  //   }
  //   setOneTimeValueAndPercentage(valueAndPercentage);
  //  //   console.log("Value Perc:", valueAndPercentage);
  //  //   console.log("One Time Terms:", oneTimeTerms);
  //   return oneTimeTerms;
  // }

  async function generateOneTimeTerms(maxValue) {
    const oneTimeTerms = [];
    const valueAndPercentage = [];

    // Ordenar maxValue por max_installments para garantir que começamos com as menores parcelas
    maxValue.sort((a, b) => a.max_installments - b.max_installments);

    let currentMaxInstallments = 0;

    for (const term of maxValue) {
      const { max_installments, percentage } = term;
      const discountValue =
        (parseFloat(landValue).toFixed(2) * parseFloat(percentage)) / 100;

      for (let i = currentMaxInstallments + 1; i <= max_installments; i++) {
        const labelValue = (landValue - discountValue) / i;
        oneTimeTerms.push({
          value: i,
          label: `${i}x - ${formatCurrency(labelValue.toString())}`,
        });

        // Somente adiciona ao valueAndPercentage se for a última parcela
        // if (i === max_installments) {
        //   valueAndPercentage.push({
        //     term: max_installments,
        //     percentage: percentage,
        //     value: landValue - discountValue,
        //   });
        // }

        valueAndPercentage.push({
          term: i,
          percentage: percentage,
          value: landValue - discountValue,
        });
      }

      currentMaxInstallments = max_installments;
    }

    setOneTimeValueAndPercentage(valueAndPercentage);
    return oneTimeTerms;
  }

  async function calculateSimpleInterestPayment(value, rate, selectedTerm) {
    const totalInterest = value * rate * selectedTerm;
    const installmentValue = (value + totalInterest) / selectedTerm;

    const payments = Array.from({ length: selectedTerm }, (_, i) => {
      const payment = installmentValue.toFixed(3);
      return {
        installment: `${i + 1} X`,
        payment: payment,
        total: payment,
        interest: (totalInterest / selectedTerm).toFixed(2),
        amortization: (installmentValue - totalInterest / selectedTerm).toFixed(
          2
        ),
      };
    });

    return { payments, totalInterest: totalInterest.toFixed(2) };
  }

  async function calculateSoEduardoPayments(value, rate, selectedTerm) {
    const r = rate * 12;
    const n = selectedTerm;
    let total = 0;
    let totalInterest = 0;
    let bestTerm = Number.MAX_SAFE_INTEGER;

    const payments = [];
    let currentPayment = value / n; // Valor base da parcela sem juros

    for (let i = 1; i <= n; i++) {
      let payment;

      if (i <= 12) {
        // Primeiras 12 parcelas: sem juros
        payment = currentPayment;
      } else {
        // A partir da parcela 13: aplica juros compostos anualmente
        const yearsPassed = Math.floor((i - 13) / 12) + 1;
        payment = currentPayment * Math.pow(1 + r, yearsPassed);
      }

      total += payment;

      // Calcula juros apenas para parcelas com juros aplicados
      if (i > 12) {
        totalInterest += payment - currentPayment;
      }

      if (payment < bestTerm) {
        bestTerm = payment;
      }

      payments.push({
        installment: `${i} X`,
        total: formatCurrency(payment.toFixed(3)),
      });
    }

    return {
      payments,
      bestTerm: bestTerm.toFixed(2),
      total: total.toFixed(2),
      totalInterest: totalInterest.toFixed(2),
    };
  }

  async function calculatePricePayments(value, rate, selectedTerm) {
    //    console.log("Valor: ", value);
    //    console.log("Valor: ", typeof value);
    //    console.log("Rate: ", rate);
    //    console.log("SelectedTerm: ", selectedTerm);

    const r = rate;
    const n = selectedTerm;
    const payments = [];

    let payment;
    if (r !== 0) {
      payment = (value * r) / (1 - Math.pow(1 + r, -n));
    } else {
      payment = value / n; // Pagamento sem juros
    }

    let remainingBalance = value;
    let totalInterest = 0;
    for (let i = 1; i <= n; i++) {
      const interest = r !== 0 ? remainingBalance * r : 0;
      const amortization = payment - interest;

      payments.push({
        payment: payment.toFixed(3),
        total: payment.toFixed(2),
        interest: interest.toFixed(2),
        amortization: amortization.toFixed(2),
      });
      totalInterest += parseFloat(interest.toFixed(2));
      remainingBalance -= amortization;
    }

    //    console.log({ payments, totalInterest });
    return { payments, totalInterest };
  }

  async function calculateSACPayments(value, rate, selectedTerm) {
    const r = rate;
    const n = selectedTerm;
    let total = 0;
    let totalInterest = 0;
    let bestTerm = Number.MAX_SAFE_INTEGER;

    const payments = [];

    for (let i = 1; i <= n; i++) {
      let amortization, interest, payment;
      if (r !== 0) {
        amortization = value / n;
        interest = (value * r * (n - i + 1)) / n;
        payment = parseFloat(amortization + interest).toFixed(3);
      } else {
        amortization = value / n; // Amortização sem juros
        interest = 0; // Não há juros quando a taxa é zero
        payment = parseFloat(amortization).toFixed(3); // Pagamento sem juros
      }

      total += parseFloat(payment);
      totalInterest += parseFloat(interest);

      if (parseFloat(payment) < parseFloat(bestTerm)) {
        bestTerm = parseFloat(payment);
      }

      payments.push({ installment: `${i} X`, total: formatCurrency(payment) });
    }

    return {
      payments,
      bestTerm: bestTerm.toFixed(2),
      total: total.toFixed(2),
      totalInterest: totalInterest.toFixed(2),
    };
  }

  async function calculateInverseSACPayments(value, rate, selectedTerm) {
    const r = rate;
    const n = selectedTerm;
    let total = 0;
    let totalInterest = 0;
    let bestTerm = Number.MAX_SAFE_INTEGER;

    const payments = [];

    for (let i = n; i >= 1; i--) {
      let amortization, interest, payment;
      if (r !== 0) {
        amortization = value / n;
        interest = (value * r * (n - i + 1)) / n;
        payment = parseFloat(amortization + interest).toFixed(2);
      } else {
        amortization = value / n; // Amortização sem juros
        interest = 0; // Não há juros quando a taxa é zero
        payment = parseFloat(amortization).toFixed(2); // Pagamento sem juros
      }

      total += parseFloat(payment);
      totalInterest += parseFloat(interest);

      if (parseFloat(payment) < parseFloat(bestTerm)) {
        bestTerm = parseFloat(payment);
      }

      // Corrige o número da parcela para começar do 1 até n
      payments.push({ installment: `${n - i + 1} X`, total: payment });
    }

    // console.log("SAC INVERSA: ", payments)

    return {
      payments,
      bestTerm: bestTerm.toFixed(2),
      total: total.toFixed(2),
      totalInterest: totalInterest.toFixed(2),
    };
  }

  async function calculateSACREPayments(value, rate, selectedTerm) {
    const r = rate;
    let n = selectedTerm;
    let total = 0;
    let aux_total = 0;
    let novo_cont = 0;
    let novo_valor = 0;
    let valor_financiado = value;
    const payments = [];
    let aux_date = "";

    for (let i = 1; i <= n; i++) {
      if (i == 1) {
        aux_date = 0;
      } else {
        aux_date = 1;
      }

      let amortization, interest, payment;

      if (novo_cont === 0 || novo_cont > 11) {
        if (novo_cont !== 0) {
          n = n - 12;
          novo_valor = aux_total - valor_financiado * (r / 100);
          valor_financiado = valor_financiado - novo_valor;
        }
        aux_total = valor_financiado / n + valor_financiado * (r / 100);
        novo_cont = 0;
      }

      if (novo_cont <= 12 && novo_cont !== 0) {
        novo_valor = aux_total - valor_financiado * (r / 100);
        valor_financiado = valor_financiado - novo_valor;
      }

      novo_cont++;

      amortization = value / n;
      interest = (value * r * (n - i + 1)) / n;
      payment = parseFloat(amortization + interest).toFixed(3);

      total += parseFloat(payment);
      aux_total += parseFloat(payment);

      payments.push({ installment: `${i} X`, total: formatCurrency(payment) });
    }

    return {
      payments,
      bestTerm: (total / n).toFixed(2),
      total: total.toFixed(2),
      totalInterest: (total - value).toFixed(2),
    };
  }

  async function calculateSACOCPayments(value, rate, selectedTerm) {
    const r = rate;
    const n = selectedTerm;
    let total = 0;
    let totalInterest = 0;
    let bestTerm = Number.MAX_SAFE_INTEGER;

    const payments = [];
    let payment = value / n;

    for (let i = 1; i <= n; i++) {
      payment *= 1 + r;

      total += payment;
      totalInterest += payment - value / n;

      if (payment < bestTerm) {
        bestTerm = payment;
      }

      payments.push({
        installment: `${i} X`,
        total: formatCurrency(payment.toFixed(3)),
      });
    }

    return {
      payments,
      bestTerm: bestTerm.toFixed(2),
      total: total.toFixed(2),
      totalInterest: totalInterest.toFixed(2),
    };
  }

  async function calculateVPPayments(value, rate, selectedTerm) {
    try {
      // console.log("selectedTerm: ", selectedTerm);
      // console.log("rate: ", rate);
      // console.log("value: ", value);
      const parcelValue = value / selectedTerm;
      // var taxa_anual = rate / 100;
      var taxa_mensal = rate;
      // console.log("taxa_mensal: ", taxa_mensal.toFixed(2));

      var valuePresenteTotal = 0;
      var valueParcelas = [];
      var parcelsTable = [];
      for (let i = 1; i <= selectedTerm; i++) {
        // Calcular o value presente da parcela atual
        var valuePresenteParcela = parcelValue / Math.pow(1 + taxa_mensal, i);

        // Adicionar o value presente da parcela ao total
        valuePresenteTotal += valuePresenteParcela;
        valueParcelas.push(parcelValue);
        parcelsTable.push({ installment: `${i} X`, total: parcelValue });

        // console.log("VP: ", valuePresenteParcela);
        // console.log("VParcela: ", valueParcelas);
      }

      return {
        vpTotal: valuePresenteTotal,
        vParcel: valueParcelas,
        vpTable: parcelsTable,
      };
    } catch (error) {
      return error;
    }
  }

  async function calculateInterestFreePayments(value, selectedTerm) {
    const n = selectedTerm;
    let total = 0;
    const payments = [];

    for (let i = n; i >= 1; i--) {
      const amortization = value / n;
      const payment = parseFloat(amortization).toFixed(2);
      total += parseFloat(payment);
      payments.push({ installment: `${i} X`, total: payment });
    }

    return {
      payments,
      total: total.toFixed(2),
      totalInterest: 0,
    };
  }

  async function calculateFutureValue(principal, rate, months) {
    //    console.log("principal: ", principal);
    //    console.log("rate: ", rate);
    //    console.log("months: ", months);
    try {
      const monthlyRate = rate / 100;
      let futureValue;

      if (rate !== 0) {
        futureValue =
          parseFloat(principal).toFixed(2) * Math.pow(1 + monthlyRate, months);
      } else {
        futureValue = parseFloat(principal).toFixed(2); // Se a taxa de juros for zero, o futuro valor será o mesmo que o principal
      }

      return futureValue;
    } catch (error) {
      return error;
    }
  }

  async function fetchLandsSelect(block) {
    setLoadingLands(true);
    if (!block) return;

    await getLands(block).then((res) => {
      const data = res
        .filter(land => land.status === 1)
        .map((land) => ({
          value: land.id,
          label: land.name,
        }));

      setLands(data);
      setLoadingLands(false);
    });
  }

  const calculateCorrection = () => {
    // Verifica se a data do pagamento está definida e não é retroativa

    const formatDate = formatIsoDate(date);
    const today = formatIsoDate(new Date());
    const debtorCorrection = simulatorData?.outstanding_balance_rate
      ? simulatorData.outstanding_balance_rate
      : 0;

    // console.log("First Entry date: ", firstEntryParcelDate);
    // console.log("Others Entry date: ", othersEntryParcelDate);
    // console.log("Financing formatted date: ", formatDate);
    // console.log("Today: ", today);
    // console.log("IF: formatDate >= today", Date(formatDate) >= Date(today));
    // console.log("date: ", date);
    // console.log("firstEntryParcelDate: ", firstEntryParcelDate);
    // console.log("firstEntryParcelDate: ", typeof firstEntryParcelDate);
    // console.log("othersEntryParcelDate: ", othersEntryParcelDate);
    // console.log("othersEntryParcelDate: ", typeof othersEntryParcelDate);
    // console.log("(date && Date(date) ===: ", (date && Date(date) === Date(firstEntryParcelDate)) || (Date(date) === Date(othersEntryParcelDate)));

    if (formatDate && Date(formatDate) >= Date(today)) {
      let monthsDifference = 0;
      // Calcula a diferença em meses entre a data do pagamento e a data da primeira parcela do financiamento
      if (firstEntryParcelDate && othersEntryParcelDate) {
        monthsDifference = differenceInMonths(
          date,
          new Date(othersEntryParcelDate)
        );
      } else if (firstEntryParcelDate && !othersEntryParcelDate) {
        monthsDifference = differenceInMonths(
          date,
          new Date(firstEntryParcelDate)
        );
      }

      let oneTimeValue = 0;
      if (oneTimeParcelDate !== null) {
        oneTimeValue = oneTimeParcelValue;
      }

      let intermediateValue = 0;
      if (firstIntermediateParcelDate !== null) {
        intermediateValue = intermediateFinalValue;
      }

      let constructionValue = 0;
      if (
        firstConstructionParcelDate !== null &&
        selectedConstructionTerm > 1 &&
        othersConstructionParcelDate !== null
      ) {
        constructionValue = constructionFinalValue;
      }

      let entryValueCalc = entryValue;
      if (!simulatorData?.installments_interest_entry) {
        //        console.log("entryValueCalc: ", entryValueCalc);
        //        console.log("entryValue: ", entryValue);
        //        console.log("entryInterest: ", entryInterest);

        entryValueCalc = entryValue - entryInterest;
      }

      // console.log(
      //   "landValue - entryValue - intermediateValue: ",
      //   landValue - entryValue - intermediateValue
      // );
      // console.log("simulatorData.outstanding_balance_rate: ", debtorCorrection);
      // console.log("Months Diference: ", monthsDifference);

      // console.log("Aqui acontece o cálculo do saldo devedor");
      // console.log("Valor do lote: ", landValue);
      // console.log("Valor Entrada: ", entryValueCalc);
      // console.log("Valor Intermediária: ", intermediateValue);
      // console.log("Valor Obra: ", constructionValue);
      // console.log("Valor Única: ", oneTimeValue);
      // console.log("--------------------------------------------------");
      // console.log("Total: ", (
      //   landValue -
      //   entryValueCalc -
      //   intermediateValue -
      //   constructionValue -
      //   oneTimeValue
      // ));
      // console.log("Aqui acaba o cálculo do saldo devedor");
      let futureValue;
      futureValue = calculateFutureValue(
        landValue -
        entryValueCalc -
        intermediateValue -
        constructionValue -
        oneTimeValue, // Valor financiado (saldo devedor)
        debtorCorrection, // Taxa de juros mensal
        monthsDifference // Número de meses de espera
      );
      //      console.log("Future Value: ", futureValue);
      return futureValue;
    } else {
      return 0;
    }
  };

  const generateInstallments = (installmentsData, parcelDateOne, parcelDateTwo) => {
    // Inicialize o array de parcelas
    const installmentsArray = [];

    // Converta as datas fornecidas para objetos Date
    const firstDate = new Date(parcelDateOne);
    const secondDate = parcelDateTwo ? new Date(parcelDateTwo) : null;

    // Itere sobre os dados das parcelas
    installmentsData.forEach((item, index) => {
      // Calcule a data de vencimento com base na data da primeira ou segunda parcela
      let dueDate;

      if (index === 0) {
        dueDate = firstDate;
      } else if (index === 1 && parcelDateTwo) {
        dueDate = secondDate;
      } else if (index > 1 && parcelDateTwo) {
        dueDate = addMonths(parcelDateTwo, index - 1);
      } else {
        dueDate = addMonths(firstDate, index);
      }

      // Formate a data de vencimento como "YYYY-MM-DD"
      const formattedDueDate = format(dueDate, "yyyy-MM-dd");

      // Limpeza do valor se vier com "R$"
      let cleanValue = item.total;
      if (typeof cleanValue === "string" && cleanValue.includes("R$")) {
        cleanValue = cleanValue
          .replace(/R\$\s?/, "")
          .replace(/\./g, "")
          .replace(",", ".")
          .trim();
      }

      // Crie o objeto de parcela
      const installmentObject = {
        value: cleanValue,
        due_date: formattedDueDate,
        sequence_number: `${index + 1}/${installmentsData.length}`,
        want_choose: 0, // 0 para a primeira parcela, 1 para as demais
        group_code: `${format(new Date(), "yyyyMMddHHmmss")}-${uuidv4()}`
      };

      // Adicione o objeto ao array de parcelas
      installmentsArray.push(installmentObject);
    });

    return installmentsArray;
  };

  const generateIntermediateInstallments = (installments) => {
    // console.log("Generate Installments: ", installments);
    const adjustedObj = installments.map((i, index) => {
      var stringData = i.due_date;
      var partesData = stringData.split("/");
      var novaStringData =
        partesData[2] + "-" + partesData[1] + "-" + partesData[0];
      return {
        sequence_number: `${index + 1}/${installments.length}`,
        value: formatStyledCurrency(i.value).toFixed(2),
        due_date: novaStringData,
        want_choose: simulatorData.intermediate_open ? 1 : 0,
      };
    });

    return adjustedObj;
  };

  const handleSendSimulationModal = () => {
    // console.log(toggle)
    // console.log(firstOneTimePayDate)
    // console.log(selectedOneTimePayTerm, othersOneTimePayDate, selectedOneTimePayTerm)
    // console.log(oneTimeInstallments)
    // console.log(((selectedOneTimePayTerm > 1 && othersOneTimePayDate) || selectedOneTimePayTerm === 1))
    if (
      !toggle &&
      ((date && financingParcelCalc && selectedFinancingTerm >= 1) ||
        (entryParcelValue && firstEntryParcelDate)) &&
      ((selectedEntryTerm > 1 && othersEntryParcelDate) ||
        selectedEntryTerm === 1)
    ) {
      setShowModalClient(true);
    } else if (
      toggle &&
      firstOneTimePayDate &&
      ((selectedOneTimePayTerm > 1 && othersOneTimePayDate) || selectedOneTimePayTerm === 1) &&
      oneTimeInstallments
    ) {
      setShowModalClient(true);
    } else {
      toast.error("Por favor, preencha todos os campos corretamente.");
    }
    // setShowModalClient(true);
  };

  const handleSimulation = () => {
    setSimulationDataLoading(true);
    let data;
    if (toggle) {
      const findValueAndPercentage = oneTimeValueAndPercentage.find(
        (t) => t.term === selectedOneTimePayTerm
      );

      data = {
        ...(!isPublic && { enterprise_id: parseInt(empId) }),
        ...((isPublic && enterpriseId && role === "Corretor") && { enterprise_id: parseInt(enterpriseId) }),
        land_id: simulatorData.land_id,
        client_id: clientId,
        team_id: team,
        broker_id: selectedCorr,
        real_estate_id: selectedImob,
        type_sale: toggle ? "in_cash" : "financing",
        in_cash: {
          value: findValueAndPercentage.value,
          percentage: findValueAndPercentage.percentage,
          installments: oneTimeInstallments,
        },
      };

      setSimulationData(data);
    } else {
      let entryInstallments;
      //      console.log("entryParcechooseEntryInstallments ", chooseEntryInstallments);
      //      console.log("chooseEntry: ", chooseEntry);
      // console.log(chooseEntryInstallments);
      if (!chooseEntry && entryParcelsTable) {
        entryInstallments = generateInstallments(
          entryParcelsTable,
          firstEntryParcelDate,
          othersEntryParcelDate
        );
      } else if (chooseEntry && chooseEntryInstallments) {
        entryInstallments = chooseEntryInstallments.map(e => ({
          ...e,
          due_date: format(new Date(e.due_date), "yyyy-MM-dd"),
        }));
      }

      const financingInstallments = generateInstallments(
        financingParcelsTable,
        date
      );

      let intermediateInstallments;
      if (simulatorData.intermediate_enable && intermediateFinalValue !== 0) {
        intermediateInstallments = generateIntermediateInstallments(
          intermediateParcelsTable
        );
      }

      data = {
        ...(!isPublic && { enterprise_id: parseInt(empId) }),
        ...((isPublic && enterpriseId && role === "Corretor") && { enterprise_id: parseInt(enterpriseId) }),
        land_id: simulatorData.land_id,
        client_id: clientId,
        team_id: team,
        broker_id: selectedCorr,
        real_estate_id: selectedImob,
        type_sale: toggle ? "in_cash" : "financing",
        ...(discount && {
          term_discount_value: discount
        }),
        ...(entryValue &&
          entryValue > 0 &&
          entryInstallments && {
          entry: {
            value: entryValue.toFixed(2),
            rate: simulatorData.installments_interest_entry
              ? simulatorData.entrance_rate
              : 0,
            number_installment: selectedEntryTerm,
            installment_descriptions_id: 1,
            value_rate: simulatorData.installments_interest_entry
              ? entryInterest
              : 0,
            installments: entryInstallments,
          },
        }),
        ...(date && formatStyledCurrency(financingValue) > 0 && {
          financing: {
            value: formatStyledCurrency(financingValue),
            rate: financingRate * 100,
            number_installment: selectedFinancingTerm,
            date_first_installment: date,
            debtor_correction_rate: simulatorData.outstanding_balance_rate
              ? simulatorData.outstanding_balance_rate
              : 0,
            amortization_system: selectedPricingTable,
            installment_descriptions_id: 2,
            value_rate: financingInterest,
            installments: financingInstallments,
          },
        }),
        ...(simulatorData.single_installment_enable &&
          oneTimeParcelDate !== null && {
          single: {
            value: parseFloat(oneTimeParcelValue),
            percentage: simulatorData.single_installment_percentage,
            installments: [
              {
                value: parseFloat(oneTimeParcelValue),
                due_date: format(oneTimeParcelDate, "yyyy-MM-dd"),
                sequence_number: "001/001",
                want_choose: 0,
              },
            ],
          },
        }),
        ...(simulatorData.intermediate_enable &&
          firstIntermediateParcelDate !== null && {
          intermediate: {
            value: parseFloat(intermediateTotalValue),
            rate: simulatorData.intermediate_rate,
            percentage: simulatorData.intermediate_percentage,
            period: intermediateMonthsPeriod,
            number_installment: selectedIntermediateTerm,
            date_first_installment: firstIntermediateParcelDate,
            installment_descriptions_id: 3,
            value_rate: intermediateInterest,
            installments: intermediateInstallments,
          },
        }),
        ...(simulatorData.construction_payments_enable &&
          firstConstructionParcelDate !== null && {
          construction: {
            value: parseFloat(minConstructionValue),
            rate: simulatorData.construction_payments_rate_interest,
            percentage: simulatorData.construction_payments_percentage,
            number_installment: selectedConstructionTerm,
            date_first_installment: firstConstructionParcelDate,
            installment_descriptions_id: 6,
            value_rate: constructionInterest,
            installments: constructionParcelsTable,
          },
        }),
      };

      setSimulationData(data);
    }

    if (team && selectedCorr && selectedImob && clientId) {
      sendSimulation(data).then((res) => {
        if (res && res.success) {
          setSimulationDataLoading(false);
          setStage(1);
          setSimulationId(res.data.id);
        } else {
          toast.error("Oops algo deu errado, tente novamente!");
          setSimulationDataLoading(false);
        }
      });
    } else if ((isPublic && (!role || role === 'undefined')) || (isPublic && role && role === "Cliente")) {
      data = {
        ...data,
        client: publicClientData,
      };
      setClientData({
        ...publicClientData,
        contacts: [publicClientData.phone],
      });
      //      console.log("Data public: ", data);
      sendPublicSimulation(data, hash).then((res) => {
        // console.log("Res public: ", res);
        if (res && res.success) {
          //          // console.log("Simu res: ", res);
          setSimulationDataLoading(false);
          setStage(1);
          setSimulationId(res.data.simulation_id);
        } else {
          toast.error(
            "Oops algo deu errado, veja se seu documento está correto."
          );
          setSimulationDataLoading(false);
        }
      });
    } else {
      setSimulationDataLoading(false);
      toast.error(
        "Por favor, selecione um time e um vendedor, também é obrigatório selecionar um comprador."
      );
    }
  };

  function calculateInterestFreeTotalOrderPrice(
    term,
    setSelectedOneTimePayTerm,
    oneTimePayTerms,
    setTotalOrderPrice
  ) {
    setSelectedOneTimePayTerm(term);
    const selectedTerm = oneTimePayTerms.find((t) => t.value === term);
    if (selectedTerm) {
      const slt = selectedTerm.label.split(" - ")[1];
      const total = selectedTerm.value * formatStyledCurrency(slt);
      // console.log('Valor Total:', total.toFixed(2));
      setTotalOrderPrice(total.toFixed(2));
    }
  }

  function clearStates() {
    setSkeleton(true);
    setTeam(null);
    setDate(null);
    setMember(null);
    setMemberData(null);
    setEntryParcelCalc(0);
    setFinancingParcelsTable([]);
    setFinancingValue(0);
    setCurrentBlock(null);
    setFinancingParcelCalc(0);
    setEntryParcelsTable(null);
    setCurrentLand(null);
    setClientId(null);
    setClientData(null);
    setSelectedFinancingTerm(1);
    setFinancingParcelValue(0);
    setSelectedPricingTable(null);
    setFirstEntryParcelDate(null);
    setFinancingParcelsTableVisible(false);
  }

  return (
    <SimulatorContext.Provider
      value={{
        landValue,
        setLandValue,
        hasMap,
        setHasMap,
        team,
        setTeam,
        skeleton,
        setSkeleton,
        member,
        setMember,
        members,
        setMembers,
        memberData,
        setMemberData,
        blocks,
        setBlocks,
        currentBlock,
        setCurrentBlock,
        lands,
        setLands,
        currentLand,
        setCurrentLand,
        clearStates,
        simulationDataLoading,
        setSimulationDataLoading,
        simulatorData,
        setSimulatorData,
        selectedPricingTable,
        setSelectedPricingTable,
        entryValue,
        setEntryValue,
        minEntryValue,
        setMinEntryValue,
        entryInterest,
        setEntryInterest,
        entryRange,
        setEntryRange,
        selectedEntryTerm,
        setSelectedEntryTerm,
        entryParcelValue,
        setEntryParcelValue,
        entryTerms,
        setEntryTerms,
        entryParcelsTableVisible,
        setEntryParcelsTableVisible,
        firstEntryParcelDate,
        setFirstEntryParcelDate,
        othersEntryParcelDate,
        setOthersEntryParcelDate,
        entryParcelsTable,
        setEntryParcelsTable,
        constructionValue,
        setConstructionValue,
        minConstructionValue,
        setMinConstructionValue,
        constructionRange,
        setConstructionRange,
        pricingTables,
        setPricingTables,
        date,
        setDate,
        financingValue,
        setFinancingValue,
        selectedFinancingTerm,
        setSelectedFinancingTerm,
        financingTerms,
        setFinancingTerms,
        financingParcelsTableVisible,
        setFinancingParcelsTableVisible,
        financingParcelValue,
        setFinancingParcelValue,
        firstIntermediateParcelDate,
        setFirstIntermediateParcelDate,
        selectedIntermediateTerm,
        setSelectedIntermediateTerm,
        intermediateTerms,
        setIntermediateTerms,
        intermediateParcelValue,
        setIntermediateParcelValue,
        intermediateParcelsTable,
        setIntermediateParcelsTable,
        intermediateValue,
        setIntermediateValue,
        minIntermediateValue,
        setMinIntermediateValue,
        intermediateFinalValue,
        setIntermediateFinalValue,
        intermediateRange,
        setIntermediateRange,
        oneTimePayTerms,
        setOneTimePayTerms,
        firstOneTimePayDate,
        setFirstOneTimePayDate,
        othersOneTimePayDate,
        setOthersOneTimePayDate,
        discount,
        setDiscount,
        financingParcelsTable,
        setFinancingParcelsTable,
        entryParcelCalc,
        setEntryParcelCalc,
        financingParcelCalc,
        setFinancingParcelCalc,
        totalOrderPrice,
        setTotalOrderPrice,
        showModalClient,
        setShowModalClient,
        clientId,
        setClientId,
        clientData,
        setClientData,
        financingRate,
        setFinancingRate,
        simulationData,
        setSimulationData,
        stage,
        setStage,
        testId,
        setTestId,
        crmData,
        setCrmData,
        handleTeam,
        loadingTeams,
        setLoadingTeams,
        generateEntryTerms,
        generateFinancingTerms,
        generateOneTimeTerms,
        calculateSimpleInterestPayment,
        calculatePricePayments,
        calculateSACPayments,
        calculateInverseSACPayments,
        calculateSACREPayments,
        calculateSACOCPayments,
        translatePricingTablesTagToPortuguese,
        generateInstallments,
        calculateCorrection,
        handleSendSimulationModal,
        fetchLandsSelect,
        loadingLands,
        setLoadingLands,
        handleSimulation,
        calculateInterestFreeTotalOrderPrice,
        simulationId,
        configVisible,
        setConfigVisible,
        firstVisible,
        setFirstVisible,
        imobiliarias,
        corretores,
        selectedImob,
        setSelectedImob,
        selectedCorr,
        setSelectedCorr,
        saveImageMap,
        setSaveImageMap,
        intermediateTotalValue,
        setIntermediateTotalValue,
        intermediateMonthsPeriod,
        setIntermediateMonthsPeriod,
        firstConstructionParcelDate,
        setFirstConstructionParcelDate,
        othersConstructionParcelDate,
        setOthersConstructionParcelDate,
        selectedConstructionTerm,
        setSelectedConstructionTerm,
        constructionParcelsTable,
        setConstructionParcelsTable,
        constructionTotalValue,
        setConstructionTotalValue,
        constructionFinalValue,
        setConstructionFinalValue,
        oneTimeParcelDate,
        setOneTimeParcelDate,
        oneTimeParcelValue,
        setOneTimeParcelValue,
        toggle,
        setToggle,
        selectedOneTimePayTerm,
        setSelectedOneTimePayTerm,
        oneTimeInstallments,
        setOneTimeInstallments,
        oneTimeValueAndPercentage,
        calculateInterestFreePayments,
        calculateVPPayments,
        constructionInterest,
        setConstructionInterest,
        intermediateInterest,
        setIntermediateInterest,
        financingInterest,
        setFinancingInterest,
        chooseEntry,
        setChooseEntry,
        chooseEntryInstallments,
        setChooseEntryInstallments,
        publicClientData,
        setPublicClientData,
        chooseEntryData, setChooseEntryData,
        calculateSoEduardoPayments
      }}
    >
      {children}
    </SimulatorContext.Provider>
  );
};

export const useContextSimulator = () => {
  return useContext(SimulatorContext);
};
